import { getQueryStrings } from '../shared/QueryParams';
import { TrackerType } from './TrackerType';

export const consoleTracker: TrackerType = (event) => {
  if (!window.devmode && getQueryStrings()?.devmode !== 'true') return;
  console.log('GOT TRACKER EVENT', event);
};
